import { Box, Chip, Typography } from '@mui/material';
import { RelationshipStateChip } from '../relationships/RelationshipStateChip.tsx';
import type { RenewalPath as Path } from './renewalApi.ts';

// "Jordan Sample knows them", with the state; or the people nobody here has
// written to yet, which are the ones worth knowing about.
export const RenewalPath = ({ path }: { path: Path | null }) => {
  if (!path) {
    return <Chip size="small" variant="outlined" color="warning" label="No history yet" />;
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
      <Typography variant="body2" color="text.secondary">
        {path.isYou ? 'You know them' : `${path.user.fullName} knows them`}
      </Typography>
      <RelationshipStateChip state={path.state} />
    </Box>
  );
};
